import { render } from "./HeroiconsOutlineArrowsExpand.vue?vue&type=template&id=01a1dc0d"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowsExpand.vue"]])

export default __exports__